import api from '@/libs/axios'

export default {
  getRecords: () => api.get('/system/records'),
  getRecordById: id => api.get(`/system/records/${id}`),
  editRecord: form => api.patch(`/system/records/${form.id}`, form),
  createRecord: form => api.post('/system/records', form),
  deleteRecords: array => api.delete('/system/records', array),
}
